import React from 'react';
import styled from 'styled-components';
import { HoverTooltip } from '../HoverTooltip';

const InlineEditWrapper = styled.span`
  color: ${(props) => props.theme.colors.tertiaryBrand};
  font-size: 0.9em;
  margin-left: 8px;
  white-space: nowrap;
`;

const InlineEditButton = styled.button`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  display: inline;
  font: inherit;
  padding: 0;
  text-decoration: underline;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

interface InlineEditProps {
  onClick: () => void;
  /** When set, the link is disabled and the reason is shown on hover. */
  disabledReason?: string;
}

const InlineEdit: React.FC<InlineEditProps> = ({ onClick, disabledReason }) => {
  const button = (
    <InlineEditButton disabled={!!disabledReason} onClick={onClick} type="button">
      (Edit)
    </InlineEditButton>
  );

  return (
    <InlineEditWrapper>
      {disabledReason ? <HoverTooltip tooltip={disabledReason}>{button}</HoverTooltip> : button}
    </InlineEditWrapper>
  );
};

export default InlineEdit;
